<template>
  <div>
    <div class="cropper-container">
      <Cropper
        :src="image"
        ref="cropper"
        class="cropper mb-2"
        :stencil-component="$options.components.CircleStencil"
        :maxHeight="700"
        :maxWidth="500"
        @change="onChange"
      />
      <div class="flex justify-between">
        <div class="flex">
          <button
            type="button"
            title="Zoom in"
            @click="zoomIn"
            class="mr-4"
          >
            <svg-vue
              icon="magnifying-glass-plus-solid"
              class="h-6 w-6 fill-gray"
            />
          </button>

          <button
            type="button"
            title="Zoom out"
            @click="zoomOut"
          >
            <svg-vue
              icon="magnifying-glass-minus-solid"
              class="h-6 w-6 fill-gray mr-4"
            />
          </button>

          <button
            type="button"
            title="Rotate left"
            @click="rotateLeft"
          >
            <svg-vue
              icon="rotate-left-solid"
              class="h-6 w-6 fill-gray mr-4"
            />
          </button>

          <button
            type="button"
            title="Rotate right"
            @click="rotateRight"
          >
            <svg-vue
              icon="rotate-right-solid"
              class="h-6 w-6 fill-gray mr-4"
            />
          </button>

        </div>
        <div class="flex justify-end items-center">
          <button
            class="primary-btn mr-3"
            title="Apply changes"
            type="button"
            @click="onApplyChanges"
          >Apply</button>
          <button
            class="secondary-btn"
            title="Cancel"
            type="button"
            @click="onCancelEdit"
          >Cancel</button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { Cropper, CircleStencil } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
export default {
    data() {
        return {
            result: {
                image: null,
                coordinates: null,
            },
        };
    },
    props: ['image'],
    methods: {
        onApplyChanges() {
            // TODO: pass in editted image
            const { coordinates, canvas } = this.$refs.cropper.getResult();
            this.$emit('onApplyChanges', {
                // coordinates: coordinates,
                // image: canvas.toDataURL(),
                image: this.result.image,
                coordinates: this.result.coordinates,
            });
        },
        onCancelEdit() {
            this.$emit('onCancelEdit');
        },
        onChange({ coordinates, image }) {
            this.result = {
                coordinates,
                image,
            };
        },
        zoomIn() {
            this.$refs.cropper.zoom(1.5);
        },
        zoomOut() {
            this.$refs.cropper.zoom(0.5);
        },
        rotateRight() {
            this.$refs.cropper.rotate(90);
        },
        rotateLeft() {
            this.$refs.cropper.rotate(-90);
        },
        move() {
            this.$refs.cropper.move(100, 100);
        },
    },
    components: {
        Cropper,
        CircleStencil,
    },
};
</script>